import * as React from 'react'
import { datalayerHandler } from '../../../utils/datalayer'
import { useInView } from '../../../utils/hooks/hooks/useInView'
import { Image, ImageBase, ImageOptions } from '../../../utils/images'
import { Link } from '../../../utils/links'
import { maybeToMailPlusLink } from '../../../utils/mailplus'
import { quoteBlockClasses } from '../../../utils/style'
import { getClassName, htmlDecode } from '../../../utils/utils'
import { ActionProps, InviewProps } from './blocksState'

export type QuoteBlock = {
  index: number
  text: string
  author?: string
  primaryAction?: ActionProps
  image?: ImageBase & ImageOptions
  inview?: InviewProps
  company?: string
}

export type QuoteBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  contentClassName: string
  quoteClassName: string
  quoteTextClassName: string
  footerClassName: string
  authorClassName: string
  clickableWrapperClassName: string
  clickableClassName: string
  clickableLabelClassName: string
  clickableIconClassName: string
  visualClassName: string
  imageClassName: string
  imageNonExpandableClassName: string
  pictureClassName: string
  iconId: string
}>

export function QuoteBlockLayout(props: QuoteBlock) {
  const { author, image, inview, index, primaryAction, text, company } = props
  const classes = quoteBlockClasses(image !== undefined)
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("QuoteBlockLayout inView:", inview),
    !inview?.triggerOnce
  )
  const inviewClassName = getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')
  return (
    <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={inviewClassName}>
      <div className={getClassName(classes, 'innerClassName', `py-5${image ? ' row' : ''}`)}>
        {(text || author || primaryAction) && (
          <div className={getClassName(classes, 'contentClassName', `${image ? 'col-md-6 mb-4' : 'text-center'}`)}>
            {text && (
              <blockquote className={getClassName(classes, 'quoteClassName', '')}>
                <p className={getClassName(classes, 'quoteTextClassName', 'h4')}>{htmlDecode(text)}</p>
              </blockquote>
            )}

            {author && (
              <figcaption
                className={getClassName(
                  classes,
                  'authorClassName',
                  'mb-3 text-muted'
                )}
              >
                <cite>{author}</cite>
                {/* [not CUSTOM & HARCODED anymore */}
                {company && (
                  <p className="block__company text--xs">{company}</p>
                )}
              </figcaption>
            )}

            {primaryAction && primaryAction.title && (
              <footer className={getClassName(classes, 'footerClassName', '')}>
                <div className={getClassName(classes, 'clickableWrapperClassName', 'd-inline-block')}>
                  <Link
                    url={primaryAction.url}
                    title={primaryAction.title}
                    className={getClassName(classes, 'clickableClassName', 'btn btn-dark d-inline-flex')}
                    onClick={() =>
                      datalayerHandler('quote', undefined, undefined, {
                        kind: 'link',
                        link: maybeToMailPlusLink(primaryAction.url),
                        label: primaryAction.title,
                      })
                    }
                  >
                    <span className={getClassName(classes, 'clickableLabelClassName', '')}>
                      {htmlDecode(primaryAction.title)}
                    </span>
                    {primaryAction.SVGIcon && (
                      <svg
                        className={getClassName(classes, 'clickableIconClassName', 'ml-3')}
                        aria-hidden="true"
                        width={primaryAction.SVGIcon.width ? primaryAction.SVGIcon.width : '24px'}
                        height={primaryAction.SVGIcon.height ? primaryAction.SVGIcon.height : '24px'}
                      >
                        <use xlinkHref={getClassName(classes, 'iconId', '#icon--chevron-right-large')} />
                      </svg>
                    )}
                  </Link>
                </div>
              </footer>
            )}
          </div>
        )}

        {
          image && (
            <div className={getClassName(classes, 'visualClassName', 'col-md-6 mb-4')}>
              <Image
                {...image}
                classNames={{
                  image: getClassName(classes, (image?.keepOriginalSize ? 'imageNonExpandableClassName' : 'imageClassName'), 'w-100'),
                  picture: getClassName(classes, 'pictureClassName', ''),
                }}
              />
            </div>
          )}
      </div>
    </section>
  )
}
